import React from "react";

// Pencil/edit glyph (paths from DigitalTwin/EditIcon) recolored with the
// blue->indigo onboarding gradient so it matches the other import-type icons.
const InventoryUpdateIcon = ({
    width = 23,
    height = 23,
    viewBox = "0 0 16 16",
    ...props
}) => (
    <svg
        width={width}
        height={height}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M6.162 12.6667H14V14.0001H2V11.1714L8.6 4.57139L11.428 7.40072L6.16133 12.6667H6.162Z"
            fill="url(#paint0_linear_inventory_update)"
        />
        <path
            d="M9.542 3.62939L10.9567 2.21472C11.0817 2.08974 11.2512 2.01953 11.428 2.01953C11.6048 2.01953 11.7743 2.08974 11.8993 2.21472L13.7853 4.10072C13.9103 4.22574 13.9805 4.39528 13.9805 4.57206C13.9805 4.74883 13.9103 4.91837 13.7853 5.04339L12.3707 6.45739L9.54267 3.62939H9.542Z"
            fill="url(#paint0_linear_inventory_update)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_inventory_update"
                x1="2"
                y1="2"
                x2="14"
                y2="14"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#7D81F6" />
                <stop offset="1" stopColor="#0D14BE" />
            </linearGradient>
        </defs>
    </svg>
);

export default InventoryUpdateIcon;
